export const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT || '/api';
export const LEGACY_PORTAL_URL =
  process.env.REACT_APP_LEGACY_PORTAL_URL || 'https://cloudportal.amx360.com';
